<script lang="ts">
  import type { AiScoreBreakdown } from '$lib/types';

  let { score }: { score: AiScoreBreakdown } = $props();

  function scoreColor(total: number): string {
    if (total >= 80) return 'var(--gold)';
    if (total >= 60) return 'var(--green)';
    if (total >= 40) return 'var(--cyan)';
    return 'var(--text-muted)';
  }

  function barColor(name: string): string {
    const colors: Record<string, string> = {
      Composition: 'var(--pink)',
      'Audio Quality': 'var(--cyan)',
      'Emotional Impact': 'var(--purple)',
      'Market Appeal': 'var(--green)',
    };
    return colors[name] ?? 'var(--cyan)';
  }
</script>

<div class="ai-breakdown">
  <div class="total-score" style="color: {scoreColor(score.total)}">
    <span class="total-num">{score.total}</span>
    <span class="total-max">/100</span>
  </div>

  <div class="dimensions">
    {#each score.dimensions as dim}
      <div class="dim">
        <div class="dim-header">
          <span class="dim-name">{dim.name}</span>
          <span class="dim-score">{dim.score}/{dim.max}</span>
        </div>
        <div class="dim-bar">
          <div class="dim-fill" style="width: {(dim.score / dim.max) * 100}%; background: {barColor(dim.name)}"></div>
        </div>
        {#if dim.note}
          <p class="dim-note">{dim.note}</p>
        {/if}
      </div>
    {/each}
  </div>

  {#if score.scored_at}
    <p class="scored-at">Scored {new Date(score.scored_at).toLocaleDateString()}</p>
  {/if}
</div>

<style>
  .ai-breakdown {
    padding: 1rem 0;
  }

  .total-score {
    text-align: center;
    margin-bottom: 1.25rem;
  }
  .total-num {
    font-size: 3rem;
    font-weight: 800;
    letter-spacing: -1px;
  }
  .total-max {
    font-size: 1.2rem;
    color: var(--text-muted);
    vertical-align: super;
  }

  .dimensions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .dim-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.25rem;
  }
  .dim-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--text);
  }
  .dim-score {
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--text-secondary);
  }

  .dim-bar {
    height: 6px;
    background: var(--surface-2);
    border-radius: 3px;
    overflow: hidden;
  }
  .dim-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.6s ease;
  }

  .dim-note {
    font-size: 0.75rem;
    color: var(--text-muted);
    margin-top: 0.25rem;
    line-height: 1.4;
  }

  .scored-at {
    text-align: center;
    font-size: 0.7rem;
    color: var(--text-muted);
    margin-top: 1rem;
  }
</style>
